var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useMemo, useRef, useState } from 'react';
import { Button, Typography, ScreenContainer, ContentFrame, LayoutControls, LayoutContent, } from '@pinwheel/origami';
import { useSelector } from 'react-redux';
import { datadogLogs } from '@datadog/browser-logs';
import { satisfies } from 'compare-versions';
import ModalHeader from '../../components/ModalHeader';
import { useOpts } from '../../context';
import useGenerateDDForm from '../../hooks/useGenerateDDForm';
import Loading from '../../LinkApiRouter/components/Loading';
import { TemplateContinue } from '../../components/TemplateContinue';
import { ErrorImage } from '../../LinkApiRouter/views/Error';
import { useDDFormContext } from '../../hooks/useDDFormContext';
import getSelectedBankInfo from '../../utils/dd-forms/get-selected-bank-info';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
// Temporary ignore to unblock while we find a fix for betterer and svg:
// Cannot find module '../../assets/dd-form.svg' or its corresponding type declarations;
// @ts-ignore
import ddFormImage from '../../assets/dd-form.svg';
import useDownloadResource from '../../hooks/useDownloadResource';
import { selectDevicePlatform, selectFeatureFlags, selectLinkParams, selectLinkTokenPayload, } from '../../state/slices/slice-link-params';
import { postParentWindowMessage } from '../../utils/post-message';
import useUserEnteredBankInfo from '../../hooks/useUserEnteredBankInfo';
import { isDeviceAndroid, isDeviceIOS } from '../../utils/device-detection';
import { useReturnButtonText } from '../../hooks/useReturnButtonText';
import { useAppSelector } from '../../state';
import { checkHackyWorkspace } from '../../utils/hacky-workspace-customizations';
var loadBase64DataForAndroid = function (blobUrl, fileName) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', blobUrl, true);
    xhr.setRequestHeader('Content-type', 'application/pdf');
    xhr.responseType = 'blob';
    xhr.onload = function () {
        if (xhr.status === 200) {
            var blobResponse = xhr.response;
            var fileReaderInstance_1 = new FileReader();
            fileReaderInstance_1.readAsDataURL(blobResponse);
            fileReaderInstance_1.onloadend = function () {
                var base64Data = fileReaderInstance_1.result;
                if (base64Data && typeof base64Data === 'string') {
                    if (base64Data.startsWith('data:application/pdf;base64,')) {
                        base64Data = base64Data.replace('data:application/pdf;base64,', '');
                    }
                    postParentWindowMessage({
                        type: 'PINWHEEL_DOWNLOAD_EVENT',
                        eventName: 'download_event',
                        payload: {
                            base64Data: base64Data,
                            fileName: fileName,
                        },
                    });
                }
            };
        }
    };
    xhr.send();
};
var DocumentDisplay = function () {
    var _a, _b, _c, _d, _e;
    var _f = useDDFormContext(), goBack = _f.goBack, userName = _f.userName, employerName = _f.employerName, signatureStyle = _f.signatureStyle, bankInfos = _f.bankInfos, setFormUrl = _f.setFormUrl, formUrl = _f.formUrl;
    var getLocalizedString = useGetLocalizedString();
    var featureFlags = useSelector(selectFeatureFlags);
    var opts = useOpts();
    var fireClientEvent = opts.fireClientEvent, amountSelection = opts.amountSelection, exit = opts.exit;
    // TODO: ideally we should be checking the environment explicitly instead
    //       of having this be manually configured via a FF.
    var useAndroidDDFormsWorkaround = isDeviceAndroid() && featureFlags.androidDDFormsDownloadWorkaround;
    var buttonText = getLocalizedString(useAndroidDDFormsWorkaround ? 'VIEW_COMPLETED_FORM' : 'DOWNLOAD');
    var buttonEventId = 'DDForm-download';
    // Create a hidden anchor tag, used below for downloading the form
    var downloadAnchorRef = useRef(null);
    var _g = useSelector(selectLinkParams), sdk = _g.sdk, version = _g.version;
    var _h = useDownloadResource(formUrl), blob = _h.blob, blobUrl = _h.blobUrl, blobUrlLoaded = _h.blobUrlLoaded;
    // Extract document ID from blob URL to use in the filename.
    // We need each form to have a unique name particularly for android, which silently overwrites any existing files
    // with the same name.
    var fileName = useMemo(function () {
        var blobUrlComponents = blobUrl.split('/');
        var documentId = blobUrlComponents[blobUrlComponents.length - 1];
        return "direct_deposit_form_".concat(documentId, ".pdf");
    }, [blobUrl]);
    var userEnteredBankInfo = useUserEnteredBankInfo();
    var selectedBankInfo = useMemo(function () { return getSelectedBankInfo(bankInfos); }, [bankInfos]);
    // Show an exit button once the download button is clicked
    var _j = useState(false), hasDownloaded = _j[0], setHasDownloaded = _j[1];
    var _k = useGenerateDDForm(userName, employerName, signatureStyle, {
        type: (amountSelection === null || amountSelection === void 0 ? void 0 : amountSelection.action) === 'partial_switch'
            ? (_a = amountSelection === null || amountSelection === void 0 ? void 0 : amountSelection.allocation) === null || _a === void 0 ? void 0 : _a.type
            : null,
        value: (amountSelection === null || amountSelection === void 0 ? void 0 : amountSelection.action) === 'partial_switch' &&
            ((_b = amountSelection === null || amountSelection === void 0 ? void 0 : amountSelection.allocation) === null || _b === void 0 ? void 0 : _b.type) === 'amount'
            ? (_c = amountSelection === null || amountSelection === void 0 ? void 0 : amountSelection.allocation) === null || _c === void 0 ? void 0 : _c.value
            : (amountSelection === null || amountSelection === void 0 ? void 0 : amountSelection.action) === 'partial_switch' &&
                ((_d = amountSelection === null || amountSelection === void 0 ? void 0 : amountSelection.allocation) === null || _d === void 0 ? void 0 : _d.type) === 'percentage'
                ? (_e = amountSelection === null || amountSelection === void 0 ? void 0 : amountSelection.allocation) === null || _e === void 0 ? void 0 : _e.value
                : null,
        target: selectedBankInfo
            ? {
                id: selectedBankInfo.id,
            }
            : {
                type: userEnteredBankInfo ? userEnteredBankInfo.accountType : null,
                name: userEnteredBankInfo ? userEnteredBankInfo.accountName : null,
                routingNumber: userEnteredBankInfo
                    ? userEnteredBankInfo.routingNumber
                    : null,
                accountNumber: userEnteredBankInfo
                    ? userEnteredBankInfo.accountNumber
                    : null,
            },
    }, amountSelection === null || amountSelection === void 0 ? void 0 : amountSelection.action, {
        onResult: function (result) {
            setFormUrl(result.url);
            fireClientEvent('dd_form_create', { url: result.url });
        },
    }), loading = _k.loading, data = _k.data, error = _k.error;
    var devicePlatform = useAppSelector(selectDevicePlatform);
    var handleDownloadButtonClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var blobFile, shareError_1;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    fireClientEvent('dd_form_download', {});
                    setHasDownloaded(true);
                    // Some customers e.g. Credit Karma download the form within their own iframe,
                    // so we skip the download in those cases
                    if (featureFlags.skipDDFormDownload)
                        return [2 /*return*/];
                    if (!
                    // CORE-1931: pure JS/web downloads don't work inside an Android webview,
                    // requiring a native solution. Currently, we pass the PDF URL to the SDK,
                    // which then triggers the download via native Android. However, we also
                    // need to support the previous implementation on older versions of our
                    // SDK (see below).
                    (sdk === 'android' &&
                        // TODO: add equivalent version check for react-native SDK once update is released
                        satisfies("".concat(version.major, ".").concat(version.minor, ".").concat(version.patch), '>=3.1.4'))) 
                    // CORE-1931: pure JS/web downloads don't work inside an Android webview,
                    // requiring a native solution. Currently, we pass the PDF URL to the SDK,
                    // which then triggers the download via native Android. However, we also
                    // need to support the previous implementation on older versions of our
                    // SDK (see below).
                    return [3 /*break*/, 1];
                    if (formUrl) {
                        postParentWindowMessage({
                            type: 'PINWHEEL_URL_DOWNLOAD_EVENT',
                            eventName: 'url_download_event',
                            payload: {
                                url: formUrl,
                                fileName: fileName,
                            },
                        });
                    }
                    else {
                        // Should be functionally unreachable, but included to be safe
                        datadogLogs.logger.error('DD form form URL empty');
                    }
                    return [3 /*break*/, 11];
                case 1:
                    if (!
                    // Explicitly convert the blob content to base64 and then post it to the
                    // SDK via a window message. Note that this implementation is deprecated
                    // and the newest versions of the SDK have an updated implementation.
                    // However, this code remains for backwards compatibility.
                    (sdk === 'android' &&
                        satisfies("".concat(version.major, ".").concat(version.minor, ".").concat(version.patch), '>=2.4.1'))) 
                    // Explicitly convert the blob content to base64 and then post it to the
                    // SDK via a window message. Note that this implementation is deprecated
                    // and the newest versions of the SDK have an updated implementation.
                    // However, this code remains for backwards compatibility.
                    return [3 /*break*/, 2];
                    loadBase64DataForAndroid(blobUrl, fileName);
                    return [3 /*break*/, 11];
                case 2:
                    if (!useAndroidDDFormsWorkaround) return [3 /*break*/, 3];
                    (_a = downloadAnchorRef.current) === null || _a === void 0 ? void 0 : _a.click();
                    return [3 /*break*/, 11];
                case 3:
                    if (!
                    // On iOS, the anchor ref download does not work, so try invoking the
                    // native device's "share" functionality instead.
                    (isDeviceIOS() ||
                        // Explicitly check for an iOS mobile SDK. We probably don't need this
                        // check since `isDeviceIOS()` should cover this case as well, but this is
                        // included here to be safe.
                        devicePlatform === 'ios')) 
                    // On iOS, the anchor ref download does not work, so try invoking the
                    // native device's "share" functionality instead.
                    return [3 /*break*/, 10];
                    _e.label = 4;
                case 4:
                    _e.trys.push([4, 8, , 9]);
                    blobFile = {
                        files: [
                            new File([blob], fileName, {
                                type: 'application/pdf',
                            }),
                        ],
                    };
                    if (!(typeof navigator.share === 'function' &&
                        navigator.canShare(blobFile))) return [3 /*break*/, 6];
                    return [4 /*yield*/, navigator.share(blobFile)];
                case 5:
                    _e.sent();
                    return [3 /*break*/, 7];
                case 6:
                    // Try the anchor ref download as a last resort
                    (_b = downloadAnchorRef.current) === null || _b === void 0 ? void 0 : _b.click();
                    _e.label = 7;
                case 7: return [3 /*break*/, 9];
                case 8:
                    shareError_1 = _e.sent();
                    datadogLogs.logger.log('DD form share error', {
                        unknownError: shareError_1,
                    });
                    // Try the anchor ref download as a last resort
                    (_c = downloadAnchorRef.current) === null || _c === void 0 ? void 0 : _c.click();
                    return [3 /*break*/, 9];
                case 9: return [3 /*break*/, 11];
                case 10:
                    (_d = downloadAnchorRef.current) === null || _d === void 0 ? void 0 : _d.click();
                    _e.label = 11;
                case 11: return [2 /*return*/];
            }
        });
    }); };
    var linkTokenPayload = useAppSelector(selectLinkTokenPayload);
    var defaultReturnButtonText = useReturnButtonText();
    var returnButtonText = checkHackyWorkspace('Berkshire Bank', linkTokenPayload.workspaceName)
        ? getLocalizedString('RETURN_TO_MAIN_MENU')
        : defaultReturnButtonText;
    if (loading) {
        return (React.createElement(ScreenContainer, null,
            React.createElement(ContentFrame, null,
                React.createElement(Loading, null))));
    }
    if (error || (data && data.error)) {
        return (React.createElement(ScreenContainer, null,
            React.createElement(ContentFrame, null,
                React.createElement(TemplateContinue, { Image: ErrorImage, title: getLocalizedString('DD_FORM_GENERATION_ERROR'), subtitle: getLocalizedString('PLEASE_TRY_AGAIN'), buttonLabel: getLocalizedString('CLOSE'), buttonEventId: "Error-continue", onContinue: exit }))));
    }
    return (React.createElement(ScreenContainer, null,
        React.createElement(ModalHeader, { onBack: goBack, disableExitConfirmation: true }),
        React.createElement(ContentFrame, null,
            React.createElement(LayoutContent, null,
                React.createElement("div", { style: {
                        display: 'flex',
                        flex: 1,
                        alignItems: 'center',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        textAlign: 'center',
                    }, "data-testid": "DDFormDocumentDisplay" },
                    React.createElement("img", { src: ddFormImage, alt: "logo-dd-form" }),
                    React.createElement(Typography, { sx: { margin: '16px 0' }, variant: "header", as: "h2" }, getLocalizedString('FORM_READY_TITLE')),
                    React.createElement(Typography, { variant: "body", color: "light", align: "center" }, getLocalizedString('FORM_READY_DESCRIPTION')))),
            React.createElement(LayoutControls, null,
                React.createElement("a", { ref: downloadAnchorRef, href: 
                    // HACK/TODO: blobUrl doesn't work on Android
                    useAndroidDDFormsWorkaround ? formUrl : blobUrl, download: fileName, target: "_blank", rel: "noreferrer", 
                    // Don't show, we want to programmatically trigger this with the <Button>
                    hidden: true }, buttonText),
                hasDownloaded && featureFlags.showExitButtonAfterDDFormDownload && (React.createElement(Button, { variant: "outline", eventId: "DDForm-exit", dataTestId: "DDForm-exit", onClick: function () { return exit(); } }, returnButtonText)),
                React.createElement(Button, { eventId: buttonEventId, dataTestId: blobUrlLoaded ? buttonEventId : 'DDForm-loading', disabled: !blobUrlLoaded, onClick: handleDownloadButtonClick }, blobUrlLoaded ? buttonText : getLocalizedString('LOADING'))))));
};
export default DocumentDisplay;
